function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgExclamationYellow = function SvgExclamationYellow(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 103,
    height: 100,
    viewBox: "0 0 103 100",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M91.3859 75.747C96.1696 68.1323 98.9461 59.1292 98.9461 49.473C98.9461 22.1498 76.7961 0 49.4731 0C22.1499 0 0 22.1498 0 49.473C0 76.7961 22.1499 98.9461 49.4731 98.9461C59.9035 98.9461 69.5743 95.7104 77.5524 90.1991L102.644 100L91.3859 75.747ZM49.4731 81.8882C44.9703 81.8882 41.3201 78.2381 41.3201 73.7353C41.3201 69.2326 44.9703 65.5825 49.4731 65.5825C53.9758 65.5825 57.6261 69.2326 57.6261 73.7353C57.6261 78.2381 53.9758 81.8882 49.4731 81.8882ZM49.4731 59.541C43.3172 59.541 38.2806 22.1069 38.2806 22.1069C38.2806 19.9745 43.3172 18.2301 49.4731 18.2301C55.6288 18.2301 60.6653 19.9745 60.6653 22.1069C60.6653 22.1069 55.6288 59.541 49.4731 59.541Z",
    style: {
      fill: "var(--color-primary)"
    }
  }));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgExclamationYellow, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/exclamation-yellow.57f46077.svg";
export { ForwardRef as ReactComponent };